import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function Code(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Код';
    }

    const getType = () => {
        return 'code';
    }

    const getTitle = () => {
        return 'Код за бързо избиране от клавиатура';
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(Code)